export const OUTER_STATE = 'OUTER_STATE';
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const BASIC_STATE = 'BASIC_STATE';
export const PHONEME_STATE = 'PHONEME_STATE';
export const PHONEME_ROW_STATE = 'PHONEME_ROW_STATE';
export const PHONEME_ALL_STATE = 'PHONEME_ALL_STATE';
export const RESET_STATE = 'RESET_STATE';
